const SUBTITLES = {
  ar: 'أعشاب طبيعية ومنتجات صحية',
  fr: 'Herbes Naturelles & Produits de Santé',
  en: 'Herbs & Natural Products',
};

const Loading = () => {
  const lang = localStorage.getItem('lang') || 'ar';
  const subtitle = SUBTITLES[lang] || SUBTITLES.ar;

  return (
    <div className="fixed inset-0 w-screen h-screen flex items-center justify-center bg-white z-[9999]">
      <div className="flex flex-col items-center gap-8">

        {/* Logo */}
        <div className="relative">
          <div className="absolute inset-0 rounded-full bg-emerald-100 animate-ping opacity-30 scale-110" />
          <div className="relative w-28 h-28 rounded-full bg-emerald-50 border border-emerald-100 flex items-center justify-center">
            <img src="/logo.png" alt="BenMoussa" className="w-20 h-20 object-contain" />
          </div>
        </div>

        {/* Brand name */}
        <div className="text-center space-y-1">
          <p className="text-base font-black text-gray-900 tracking-widest uppercase">BenMoussa</p>
          <p className="text-xs font-bold text-gray-400 tracking-wider">{subtitle}</p>
        </div>

        {/* Loading bar */}
        <div className="w-32 h-1 bg-gray-100 rounded-full overflow-hidden">
          <div className="h-full bg-emerald-500 rounded-full animate-[loading-bar_1.4s_ease-in-out_infinite]" />
        </div>

      </div>

      <style>{`
        @keyframes loading-bar {
          0%   { width: 0%;   margin-left: 0; }
          50%  { width: 70%;  margin-left: 15%; }
          100% { width: 0%;   margin-left: 100%; }
        }
      `}</style>
    </div>
  );
};

export default Loading;
